export default [
  {
    header: "Neteges",
  },
  {
    icon: "CalendarIcon",
    title: "Planning",
    route: "foravila-cleaning-planning",
  },
];
